import React, { Component } from 'react'
import { connect } from 'react-redux'
import { showMessageModal } from '../../../redux/actions/miscActions'
import { addNewProduct } from '../../../redux/actions/productActions'
import {OWNER_NAME, CLIENT_ID } from '../../../utils/config'
import { Form, Input, Select  } from 'antd'

const { TextArea } = Input;
const { Option } = Select;

export class ProductForm extends Component {
  constructor(props){
    super(props)
    this.state={
      imgPreview: '',
      productImage: '',
      productNaam: '',
      productCategorie: '',
      productPrijs: '',
      productEenheid: '',
      productOmschrijving: '',
      productId: '',
      productOnSale: false,
      productAttributen: [],
      isVisible: false,
      productOwner: CLIENT_ID,
      ownerName: OWNER_NAME
    }
  }

  handleImageSelect = (e) => {
    
    if (e.target.files.length === 1) {
      const imgPreview = URL.createObjectURL(e.target.files[0]);
      this.setState({
        imgPreview,
        productImage: e.target.files[0],
      });
    }
  };

  handleInput=(e)=>{
    this.setState({
      [e.target.name]: e.target.value
    })
  }


  handleNumberInput=(e)=>{
    if(e.target.value.match(/^[0-9]+([0-9,]{1,3})?$/gm)){
      this.setState({
        [e.target.name]: e.target.value
      })
    } else if (e.target.value.length === 0){
      this.setState({
        [e.target.name]: ''
      })
    }
  }

  handleCatSelect=(value)=>{    
    this.setState({
      productCategorie: value
    })
  }

  handleProductEenheid=(value)=>{    
    this.setState({
      productEenheid: value
    })
  }

  handleAttributenSelect=(value)=>{
    this.setState({
      productAttributen: value
    })
  }

  handleFormSave=()=>{
    const feedback = {
      type: 'loading',
      txt: 'Aan het opslaan' 
    }
    this.props.showMessageModal(feedback)
    this.state.productPrijs = this.state.productPrijs.replace(/,/g, '.')
    this.props.addNewProduct(this.state)
  }

  componentDidUpdate=(prevProps)=>{
    if(prevProps.misc.messageType === 'success'){
      this.setState({
        imgPreview: '',
        productImage: '',
        productNaam: '',
        productCategorie: '',
        productPrijs: '',
        productEenheid: '',
        productOmschrijving: '',
        productId: '',
        productOnSale: false,
        productAttributen: [],
        isVisible: false,
        productOwner: CLIENT_ID,
        ownerName: OWNER_NAME
      })
    }
  }
  
  render() {
    const { 
    imgPreview,
    productNaam,
    productCategorie,
    productPrijs,
    productEenheid,
    productOmschrijving,
    productId,
    productAttributen} = this.state

    const attributen = [
      <Option key="Bevroren">Bevroren</Option>,
      <Option key="Bosjes">Bosjes</Option>,
      <Option key="Cubes verpakt">Cubes verpakt</Option>,
      <Option key="Fijngesneden">Fijngesneden</Option>,
      <Option key="Geschild">Geschild</Option>,
      <Option key="Gesneden">Gesneden</Option>,
      <Option key="Heel">Heel</Option>,
      <Option key="Ongeschild">Ongeschild</Option>,
      <Option key="Sap met pulp">Sap met pulp</Option>,
      <Option key="Schoongemaakt">Schoongemaakt</Option>,
      <Option key="Uitgehold">Uitgehold</Option>,
      <Option key="Verpakt">Verpakt</Option>,
      <Option key="Vers">Vers</Option>  
    ]

    return (
      <div className="newProductForm">
        <Form layout="vertical">
            <Form.Item label="Product foto">
          <div className="image-preview">
            <img src={imgPreview} alt=""/>
              <Input
                type="file"
                className="form-control-file"
                onChange={this.handleImageSelect}                
              />
          </div>
            </Form.Item>

            <Form.Item label="Product naam" required={true}>
              <Input name="productNaam" onChange={this.handleInput} value={productNaam} />
            </Form.Item>

            <Form.Item label="Product categorie" required={true}>
              <Select value={productCategorie} onChange={this.handleCatSelect}>
                <Option value="groenten">Groenten</Option>
                <Option value="fruit">Fruit</Option>
                <Option value="sap">Sap</Option>
                <Option value="aardvrucht">Aardvrucht</Option>
                <Option value="specerijen">Specerijen</Option>
              </Select>
            </Form.Item>
       
            <Form.Item label="Product omschrijving" extra={`${productOmschrijving.length}/65`}>
              <TextArea name="productOmschrijving" onChange={this.handleInput} value={productOmschrijving} maxLength={65} />
            </Form.Item>

            <Form.Item label="Product eigenschappen" required={true}>
            <Select
                    mode="multiple"
                    placeholder="Selecteer de verschillende eigenschappen"
                    onChange={this.handleAttributenSelect}
                    value={productAttributen}
                  >
                    {attributen}
                  </Select>
            </Form.Item>

            <Form.Item label="Prijs" required={true}>
              <Input prefix="SRD"  name="productPrijs" onChange={this.handleNumberInput} value={productPrijs} />
            </Form.Item>

            <Form.Item label="Product eenheid" required={true}>
              <Select value={productEenheid} onChange={this.handleProductEenheid}>
                <Option value="stuk">stuk</Option>
                <Option value="hoop">hoop</Option>
                <Option value="hoop(4x)">hoop(4x)</Option>
                <Option value="hoop(8x)">hoop(8x)</Option>
                <Option value="1/2 hand">1/2 hand</Option>
                <Option value="takjes(4x)">takjes(4x)</Option>
                <Option value="bosje">bosje</Option>
                <Option value="pakje">pakje</Option>
              </Select>
            </Form.Item>
          
            <Form.Item label="Product ID" required={true} help="Vul hier uw eigen product kenmerk in">
              <Input name="productId" onChange={this.handleInput} value={productId} />
            </Form.Item>

          <button onClick={this.handleFormSave} className="large-main-btn">Opslaan</button>

        </Form>
      </div>
    )
  }
}

const mapStateToProps=(state)=>({
  misc: state.misc
})

export default connect(mapStateToProps, { showMessageModal, addNewProduct })(ProductForm)
